import { Stack } from '@mantine/core';
import { Icon, Text } from '@repo/foundations';

interface ErrorStateProps {
	error: unknown;
}

export function ErrorState({ error }: ErrorStateProps) {
	return (
		<Stack h="100%" spacing="md" align="center" justify="center">
			<Icon name="alertTriangle" size="lg" color="icon/critical/default" />
			<Stack spacing="xs" align="center">
				<Text
					size="md"
					weight="semibold"
					align="center"
					color="text/critical/default"
				>
					Failed to generate preview
				</Text>
				<Text size="sm" color="text/secondary/default" align="center">
					{(error as { detail?: string })?.detail ||
						'An error occurred while generating the preview. Please try again.'}
				</Text>
			</Stack>
		</Stack>
	);
}
